import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInputGroup,
  CInputGroupText,
  CRow,
  CSpinner,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilUser } from '@coreui/icons'
import Notifications from 'src/components/notifications/NotificationsToaster'

import { AuthContext } from 'src/contexts/authContext'
import { useValidUsername } from 'src/hooks/useAuthHooks'
import { Username } from 'src/components/auth/authComponents'
import Honeypot from 'src/components/hidden/Honeypot'

const ForgotPassword = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const authContext = useContext(AuthContext)

  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false)

  const { username, setUsername, usernameIsValid } = useValidUsername('')
  const [fetchError, setFetchError] = useState('')
  const isValid = !usernameIsValid || username.length === 0

  const sendCode = async () => {
    setIsSpinnerVisible(true)
    try {
      if (!isCodeAlreadyRequestedForUser(username)) {
        await authContext.forgotPassword(username)
        storeUserCodeHandlingInfo()
      }
      navigate('/validate-forgot-password')
    } catch (err) {
      setFetchError(`Could not request a password update for user ${username}`)
      resetForm()
    } finally {
      setIsSpinnerVisible(false)
    }
  }

  const storeUserCodeHandlingInfo = () => {
    localStorage.setItem('codeRequestedBy', username)
    localStorage.setItem('codeExpiresAt', Date.now() + 300000) // plus 300k ms -> 5 min
  }

  const isCodeAlreadyRequestedForUser = (username) => {
    const userInStore = localStorage.getItem('codeRequestedBy')
    if (userInStore === username && localStorage.getItem('codeExpiresAt')) return true
  }

  //reset errors
  const resetForm = () => {
    document.getElementById('auth-forgot-password-form').reset()
    setUsername('')
  }
  useEffect(() => {
    if (username !== '') setFetchError(false)
  }, [username])

  return (
    <div className='bg-body-tertiary min-vh-100 d-flex flex-row align-items-center'>
      {fetchError ? <Notifications type='error' message={fetchError} /> : null}
      {/* Honey */}
      <Honeypot />
      {/* Honey */}
      <CContainer>
        <CRow className='justify-content-center'>
          <CCol md={5}>
            <CCard className='p-4'>
              <CCardBody>
                <CForm id='auth-forgot-password-form'>
                  <h1>{t('ForgotPassword')}</h1>
                  <p>{t('ForgotPassword.message')}</p>
                  <CInputGroup className='mb-3'>
                    <CInputGroupText>
                      <CIcon icon={cilUser} />
                    </CInputGroupText>
                    <Username usernameIsValid={usernameIsValid} setUsername={setUsername} />
                  </CInputGroup>
                  <CButton
                    disabled={isValid}
                    color='primary'
                    onClick={sendCode}
                    className='px-4'
                    tabIndex={-1}
                  >
                    {isSpinnerVisible ? (
                      <CSpinner color='light' variant='grow' size='sm' />
                    ) : (
                      t('SendCode')
                    )}
                  </CButton>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default ForgotPassword
